import { render, staticRenderFns } from "./purchaseArrivalNotice.vue?vue&type=template&id=c56a9996&scoped=true"
import script from "./purchaseArrivalNotice.vue?vue&type=script&lang=js"
export * from "./purchaseArrivalNotice.vue?vue&type=script&lang=js"
import style0 from "./purchaseArrivalNotice.vue?vue&type=style&index=0&id=c56a9996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56a9996",
  null
  
)

export default component.exports